import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TimeRange } from '@sternum/web/components/TimeRangeDropdown';

import { dashboardTimeRanges, NumberOfHistoricalDashboardIds } from '../data';
import { DashboardId } from '../models';

export interface DashboardState {
  lastUsedDashboardIds?: string[];
  isJustCreatedPerDashboardId: Record<string, boolean>;
  selectedTimeRange: TimeRange;
  isPolling: boolean;
}

const initialState: DashboardState = {
  lastUsedDashboardIds: [],
  isJustCreatedPerDashboardId: {},
  selectedTimeRange: dashboardTimeRanges[2],
  isPolling: false,
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    appendLastUsedDashboardIdAction(state, action: PayloadAction<{ dashboardId: DashboardId }>) {
      const dashboardId = action.payload.dashboardId;

      state.lastUsedDashboardIds ||= [];

      const lastUsedDashboardIds = state.lastUsedDashboardIds || [];

      if (lastUsedDashboardIds.at(-1) === dashboardId) {
        return;
      }

      lastUsedDashboardIds.push(dashboardId);
      state.lastUsedDashboardIds = lastUsedDashboardIds.slice(-NumberOfHistoricalDashboardIds);
    },

    deleteDashboardIdsAction(state, action: PayloadAction<{ dashboardIds: DashboardId[] }>) {
      const dashboardIdsToRemove = action.payload.dashboardIds;

      state.lastUsedDashboardIds ||= [];

      const lastUsedDashboardIds = (state.lastUsedDashboardIds || []).filter((dashboardId) => {
        return !dashboardIdsToRemove.includes(dashboardId);
      });

      state.lastUsedDashboardIds = lastUsedDashboardIds;
    },

    setIsJustCreatedForDashboardIdAction(
      state,
      action: PayloadAction<{ dashboardId: DashboardId; isJustCreated: boolean }>,
    ) {
      const dashboardId = action.payload.dashboardId;

      if (action.payload.isJustCreated) {
        state.isJustCreatedPerDashboardId[dashboardId] = true;
      } else {
        delete state.isJustCreatedPerDashboardId[dashboardId];
      }
    },

    selectTimeRangeAction(state, action: PayloadAction<TimeRange>) {
      state.selectedTimeRange = action.payload;
    },
    togglePolling(state) {
      state.isPolling = !state.isPolling;
    },
  },
});

export const {
  appendLastUsedDashboardIdAction,
  deleteDashboardIdsAction,
  setIsJustCreatedForDashboardIdAction,
  selectTimeRangeAction,
  togglePolling,
} = dashboardSlice.actions;
